module.exports = __webpack_public_path__ + "static/media/video.a5366307.png";